import script from "./WorkspacesTableLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkspacesTableLoader.vue?vue&type=script&setup=true&lang=js"

import "./WorkspacesTableLoader.vue?vue&type=style&index=0&id=b7b7351c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7b7351c"]])

export default __exports__